export const CaretSortUp = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 8L16 0L24 8H8Z" fill="currentColor"/>
</svg>`;
